/**
 * @export
 * @class SiteSearch
 */
import { forEach } from '../../helpers/utilities';

export class SiteSearch {
    private container = <Element>document.getElementById('js-site-search');
    private toggleBtns = document.querySelectorAll('.js-site-search__toggle');


    /**
     * Initiates our class and binds our events
     * 
     * @private
     * @memberof SiteSearch
     */
    constructor() {
        if(!this.container || !this.toggleBtns) return;

        forEach(this.toggleBtns, ({}, btn: Element) => {
            btn.addEventListener('click', () => {
                this.toggleContainer();
            });
        });
    }


    /**
     * Toggles the class to display or hide the search form
     * 
     * @private
     * @memberof SiteSearch
     */
    private toggleContainer(): void {
        this.container.classList.toggle('c-site-search--is-visible');
    }
}
